import React, { useCallback } from 'react';

import {
  ConditionsReactivateMotifSortieDto,
  MotifSortieDto,
  MotifSortieRequestDto,
  ReferentielSearchResultDtoMotifSortieDto,
} from 'lib_api/lib/api/gen';

import {
  FetchDataResult,
  TableHeaderFunctionWithoutSort,
} from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';
import { MotifSortieFormValues } from 'types/referentiels/MotifSortie';

import DashboardHeader from './DashboardHeader/DashboardHeader';
import { FilterDashboardMotifSortie } from './types';

export const buildHeader: TableHeaderFunctionWithoutSort<
  MotifSortieDto,
  FilterDashboardMotifSortie
> = (fetchedData, _selectedData, filter, setFilter) => (
  <DashboardHeader
    totalCount={fetchedData?.total ?? 0}
    filter={filter}
    setFilter={setFilter}
  />
);

export function useSearchMotifSortie(
  filter: FilterDashboardMotifSortie,
): [
  () => Promise<ReferentielSearchResultDtoMotifSortieDto>,
  (
    result: ReferentielSearchResultDtoMotifSortieDto,
  ) => FetchDataResult<MotifSortieDto>,
] {
  const controller = useApi().AdminFonctionnelControllerApi;

  return [
    () => {
      return controller.searchMotifSortieUsingSpecsUsingGET({
        filters: {
          ...filter,
        },
      });
    },
    result => {
      return {
        data: result.results.referenceDtoList,
        total: result.total,
      };
    },
  ];
}

export function buildRequestDto(
  data: MotifSortieFormValues,
): MotifSortieRequestDto {
  return {
    motif: data.motif?.trim() || null,
    commentaire: data.commentaire || null,
    delaiEffacement: data.delaiEffacement || null,
  };
}

export function useChangeValidityMotifSortie(): [
  (idCorrelation: string) => Promise<Response>,
  (idCorrelation: string) => Promise<Response>,
  (idCorrelation: string) => Promise<ConditionsReactivateMotifSortieDto>,
] {
  const controller = useApi().AdminFonctionnelControllerApi;

  const submitDeprecateReferentiel = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.deprecateMotifSortieUsingPUT(idCorrelation);
    },
    [controller],
  );

  const submitReactivateReferentiel = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.reactivateMotifSortieUsingPUT(idCorrelation);
    },
    [controller],
  );

  const conditionsReactivateReferentiel = useCallback(
    (idCorrelation: string): Promise<ConditionsReactivateMotifSortieDto> => {
      return controller.conditionReactivationMotifSortieUsingGET(idCorrelation);
    },
    [controller],
  );

  return [
    submitReactivateReferentiel,
    submitDeprecateReferentiel,
    conditionsReactivateReferentiel,
  ];
}
